var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',{directives:[{name:"highlightjs",rawName:"v-highlightjs",value:(_vm.statementString),expression:"statementString"}],attrs:{"id":"statement-viewer"}},[_vm._v("    "),_c('code',{staticClass:"json"}),_vm._v("\n")])}
var staticRenderFns = []

export { render, staticRenderFns }